import { BUTTON_PRIMARY_GRADIENT_HOVER } from "../../../theme";
import { BUTTON_PRIMARY_GRADIENT_SELECTED } from "../../../theme";
import styled from "@emotion/styled";

const DrawerItem = styled.span<{ isActive?: boolean }>`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 16px;
  gap: 16px;
  border-radius: 100px;
  background: ${(props) =>
    props.isActive ? BUTTON_PRIMARY_GRADIENT_SELECTED : "none"};
  &:hover {
    background: ${BUTTON_PRIMARY_GRADIENT_HOVER};
  }
`;

export default DrawerItem;
